import { useCallback } from 'react';
import { useEvent } from 'react-use';

import type { ChangedBy } from '@frontend/services';

type UseOnClickOutsideProps = {
  isOpen: boolean;
  localValue: string | null;
  suggestionsMenuRef: React.RefObject<HTMLDivElement>;
  formControlRef: React.MutableRefObject<HTMLDivElement> | null;
  handleClose: (submitValue?: string | null, changedBy?: ChangedBy) => void;
};

export const useOnClickOutside = ({
  isOpen,
  localValue,
  suggestionsMenuRef,
  formControlRef,
  handleClose,
}: UseOnClickOutsideProps) => {
  // Handle click outside FormControl and (if menu exists) suggestionsMenuRef
  const handleBlur = useCallback(
    ({ target }: MouseEvent) => {
      if (
        isOpen &&
        (!suggestionsMenuRef?.current ||
          !suggestionsMenuRef.current.contains(target as Node)) &&
        formControlRef?.current &&
        !formControlRef?.current.contains(target as Node)
      ) {
        handleClose(undefined, { clickedOutside: true });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isOpen, localValue, handleClose],
  );

  // Document listener to handle 'click outside' events to close the Menu
  useEvent('mousedown', handleBlur, void 0, [handleBlur]);
};
